var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[(_vm.srcsetAttr)?_c('source',{attrs:{"srcset":_vm.srcsetAttr}}):_vm._e(),_vm._v(" "),(_vm.baseSrc)?_c('img',{staticClass:"picture-image",attrs:{"src":_vm.baseSrc,"alt":null}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }